import { FC, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import { toast } from 'react-toastify';

import Form, { Item, RequiredRule } from 'devextreme-react/form';
import List from 'devextreme-react/list';
//devextreem
import { TextBox } from 'devextreme-react/text-box';
import ValidationGroup from 'devextreme-react/validation-group';
import Validator from 'devextreme-react/validator';

import { AppFieldBox, AppGroup, AppLayoutTop, AppRow } from 'components/appComponents';
import { navigation } from 'components/layout/drawer/navigation';
import { Button, SelectBox } from 'devextreme-react';
import { isSuccess } from 'utils/responseStatus';

import {
  useCreateRoleMutation,
  useEditRoleMutation,
  useLazyGetRoleClaimsQuery,
  useLazyGetRoleDetailQuery,
} from 'bus/role/role';
import { RoleCreate } from 'bus/role/types';

const GroupTemplate = (item: any) => <div>{item.groupName}</div>;

const RolesDetails: FC = () => {
  const history = useHistory();
  let { id } = useParams<{ id: string }>();

  const [getRoleClaims] = useLazyGetRoleClaimsQuery();
  const [getRoleDetail] = useLazyGetRoleDetailQuery();
  const [createRole, { isLoading: isCreateLoading }] = useCreateRoleMutation();
  const [editRole, { isLoading: isEditLoading }] = useEditRoleMutation();

  let createCatalogRoleRef = useRef<any>(null);
  let createCatalogRoleValidRef = useRef<ValidationGroup | null>(null);

  const [claims, setClaims] = useState<any[]>([]);
  const [form, setForm] = useState<RoleCreate>({
    id: null,
    name: '',
    claims: [],
    defaultPage: '',
  });

  const getRoleClaimsData = useCallback(async () => {
    const result = await getRoleClaims();
    if (isSuccess(result)) {
      const data: any = 'data' in result ? (result as any).data : (result as any);
      setClaims(data);
    }
  }, [getRoleClaims]);

  useEffect(() => {
    getRoleClaimsData();
  }, [getRoleClaimsData]);

  const getItemsRouteList = useMemo(
    () =>
      navigation([]).reduce((result: any[], { items }) => {
        result.push(...items);
        return result;
      }, []),
    [],
  );

  const onSelectedItemsChange = (args: any) => {
    if (args.name === 'selectedItemKeys') {
      setForm((prev) => ({ ...prev, claims: args.value }));
    }
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault && e.preventDefault();
    if (createCatalogRoleValidRef.current?.instance.validate().isValid) {
      if (!id) {
        await createRole({ name: form.name, claims: form.claims, defaultPage: form.defaultPage }).then((resp: any) => {
          if (isSuccess(resp)) {
            createCatalogRoleRef.current.instance.resetValues();
            history.push('/role');
            toast.success('Изменения успешно сохранены', {
              position: toast.POSITION.BOTTOM_RIGHT,
            });
          }
        });
      } else {
        await editRole({ ...form, id: +id }).then((resp: any) => {
          if (isSuccess(resp)) {
            createCatalogRoleRef.current.instance.resetValues();
            toast.success('Изменения успешно сохранены', {
              position: toast.POSITION.BOTTOM_RIGHT,
            });
            //history.push('/role');
          }
        });
      }
    }
  };

  const init = useCallback(async () => {
    if (id) {
      const result = await getRoleDetail({ id: +id });
      if (isSuccess(result)) {
        const data: any = 'data' in result ? (result as any).data : (result as any);
        setForm((prev) => ({ ...prev, ...data }));
      }
    }
  }, [getRoleDetail, id]);

  useEffect(() => {
    init();
  }, [init]);

  return (
    <>
      <AppLayoutTop title="Роль">
        <Button
          text="Сохранить"
          type="default"
          useSubmitBehavior={false}
          onClick={handleSubmit}
          disabled={isCreateLoading || isEditLoading}
        />
      </AppLayoutTop>
      <form>
        <ValidationGroup ref={createCatalogRoleValidRef}>
          <Form formData={form} ref={createCatalogRoleRef}>
            <Item colSpan={12} colCount={12} itemType="group">
              <AppRow>
                <AppGroup col={12}>
                  <AppFieldBox label="Наименование" labelTop>
                    <TextBox
                      stylingMode="underlined"
                      placeholder="Наименование"
                      mode="text"
                      value={form.name}
                      onChange={(e: any) => {
                        setForm((prev) => ({ ...prev, name: e.event.currentTarget.value }));
                      }}
                    >
                      <Validator>
                        <RequiredRule message="Заполните поле Наименование" />
                      </Validator>
                    </TextBox>
                  </AppFieldBox>

                  <AppFieldBox label="Страница по умолчанию" labelTop>
                    <SelectBox
                      stylingMode="underlined"
                      placeholder=""
                      searchEnabled
                      value={form.defaultPage}
                      onItemClick={(e) => {
                        setForm((prev) => ({ ...prev, defaultPage: e.itemData.path }));
                        //getContractorObject(e.itemData.id);
                      }}
                      displayExpr="text"
                      valueExpr="path"
                      items={getItemsRouteList}
                      //dataSource={contractorDataStore}
                    ></SelectBox>
                  </AppFieldBox>
                </AppGroup>
              </AppRow>

              <div className="title-h2 pa-1">Права</div>
              <List
                items={claims}
                grouped
                collapsibleGroups
                keyExpr="name"
                displayExpr="groupName"
                groupRender={GroupTemplate}
                itemRender={(data) => (
                  <div className="d-flex sp-btw" title={data.groupName}>
                    {data.displayName}
                  </div>
                )}
                showSelectionControls
                selectionMode="multiple"
                selectAllMode="page"
                onOptionChanged={onSelectedItemsChange}
                selectedItemKeys={form.claims}
                onContentReady={(e: any) => {
                  const items = e.component.option('items');
                  for (let i = 0; i < items.length; i++) {
                    e.component.collapseGroup(i);
                  }
                }}
              />
            </Item>
          </Form>
        </ValidationGroup>
      </form>
    </>
  );
};

export default RolesDetails;
